module.exports = __webpack_public_path__ + "img/banner.c38e11af.jpg";